export default {
  SERIAL_BEFORE_OKTA_REDIRECT: 'serialBeforeOktaRedirect',
  REGION_BEFORE_OKTA_REDIRECT: 'regionBeforeOktaRedirect',
  REGION_QUERY_NAME: 'area',
  MY_OPEN_SESSIONS: 'myOpenSession',
  TROUBLESHOOTING_ADMIN: 'troubleshootingAdmin',
  DEBOUNCE_VALUE_MS: 500,
  PRIMARY: 'primary',
  DANGER: 'danger'
} as const
